import React from 'react';

import { ReactComponent as MachineControlIcon } from './machine-control.svg';

export default function FarmbotMachineControlIcon() {
  return <MachineControlIcon width={18} />;
}
